// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wbpn","col":"styles_col__AQQ6c"};